export default "/images/vendor/flag-icons/flags/4x3/so.svg?5c685e567e1362e7896d534f5356342d";